import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { memoNamed } from '@noshiro/preact-utils';
import { writings } from '../../assets';
import { WritingsElement } from './writings-element';
export const Writings = memoNamed('Writings', () => (_jsxs("div", { children: [_jsx("h1", { children: '執筆物' }), writings.map((el) => (_jsx(WritingsElement, { body: el.body, link: el.link, subtitle: el.subtitle, title: el.title }, el.id)))] })));
